import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
export default function CallSearch() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="summary">오래 된 통화는 키워드로 검색하고, 통화내용도 들어볼 수 있어요</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<ol className="list_order"><li><h4 className="order_num">Step 1</h4><p className="order_desc">키워드만 입력하면, 쉽게 검색이 가능해요</p><Image className="img_guide" src="/image/desktop/popup/call03_01.png" alt={"\uD0A4\uC6CC\uB4DC\uB9CC \uC785\uB825\uD558\uBA74, \uC27D\uAC8C \uAC80\uC0C9\uC774 \uAC00\uB2A5\uD574\uC694"} width={100} height={100} /></li><li><h4 className="order_num">Step 2</h4><p className="order_desc">통화내용이 궁금하신가요? 녹음파일로도 확인이 가능해요</p><Image className="img_guide" src="/image/desktop/popup/call03_02.png" alt={"\uD1B5\uD654\uB0B4\uC6A9\uC774 \uAD81\uAE08\uD558\uC2E0\uAC00\uC694? \uB179\uC74C\uD30C\uC77C\uB85C\uB3C4 \uD655\uC778\uC774 \uAC00\uB2A5\uD574\uC694"} width={100} height={100} /></li></ol></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}